var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.11 66.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.9,3.86H23.75A1.8,1.8,0,0,0,22,5.65V20.36A16.08,16.08,0,0,0,38,36.44h0A16.08,16.08,0,0,0,54.11,20.36V5.65a1.79,1.79,0,0,0-1.79-1.79H49.17"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.31,
    cy: 3.86,
    r: 2.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.76,
    cy: 3.86,
    r: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,36.44V49.53A15.93,15.93,0,0,1,22.1,65.46h0A15.93,15.93,0,0,1,6.17,49.53V33.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.17,
    cy: 28.45,
    r: 5.17
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.9ff1c59d439e06ac73a3cba0458f3afe.svg";
export { ForwardRef as ReactComponent };